import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getWorkingHours, updateWorkingHours } from ".";

const useGetWorkingHours = () =>
  useQuery({
    queryKey: ["get-working-hours"],
    queryFn: () => getWorkingHours(),
    select: (res) => res,
  });

const useUpdateWorkingHours = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateWorkingHours,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-working-hours"] });
    },
  });
};

export { useGetWorkingHours, useUpdateWorkingHours };
